module.exports = __webpack_public_path__ + "static/media/6COPUOS2.572119b8.jpg";